if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      // data-skip-rate="true" → the value passed in is already in display currency
      // (used for the NZ branch where NZ$150 is the brand policy, not an AUD value to convert).
      const skipRate = this.getAttribute('data-skip-rate') === 'true';
      const rate = (!skipRate && Shopify.currency.rate) ? Number(Shopify.currency.rate) : 1;
      const freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * rate);
      const cartTotal = Number(this.getAttribute('data-cart-total'));
      const freeShippingRemaining = cartTotal - freeShippingThreshold;

      // Per-element copy override (data-text-remaining / data-text-eligible). Lets the cart pass
      // braid-aware copy ("...Install Kit") only when braids are in the bag; otherwise the global
      // locale (a universal "free Express" message) is used, so non-braid carts aren't told to
      // "add more in braids" for shipping they may already qualify for.
      const remainTpl = this.getAttribute('data-text-remaining') || window.KROWN.settings.locales.shipping_notice_remaining_to_free;
      const eligibleTxt = this.getAttribute('data-text-eligible') || window.KROWN.settings.locales.shipping_notice_eligible_for_free;

      // ----- DISTANCE RULE (2026-07-27, founder: "make it when reachable")
      // The nudge is the FIRST thing in the cart drawer. At $85 it reads "$5 more" and
      // it works, which is what creates the $90 cluster in the order data. At $17 it read
      // "$73 more", four times what she just spent, so the moment she commits the shop
      // tells her she has not spent enough. Six in ten online orders are 2-3 packs, so
      // most people who added to cart were meeting a shortfall, not an offer.
      // So: only nudge when the goal is actually within reach. Past that, show
      // reassurance instead and hide the progress bar, because a nearly-empty bar says
      // the same discouraging thing the sentence did.
      const farTxt = this.getAttribute('data-text-far');
      const reachWithin = Number(this.getAttribute('data-reach-within') || 2500);
      const textEl = this.querySelector('[data-js-free-shipping-text]');
      const sliderWrap = this.querySelector('.cart-notice__slider');

      let cartSliderWidth = 0;
      if ( freeShippingRemaining < 0 ) {
        const remainingCents = Math.abs(freeShippingRemaining);
        if ( farTxt && remainingCents > reachWithin ) {
          textEl.innerHTML = farTxt;
          this.setAttribute('data-far', 'true');
          if ( sliderWrap ) sliderWrap.style.display = 'none';
          return;
        }
        textEl.innerHTML = remainTpl.replace('{{ remaining_amount }}', this._formatMoney(remainingCents, KROWN.settings.shop_money_format).replace('.00', ''));
        cartSliderWidth = 100 - (remainingCents * 100 / freeShippingThreshold);
      } else {
        textEl.innerHTML = eligibleTxt;
        cartSliderWidth = 100;
      }
			if ( this.querySelector('[data-js-free-shipping-slider]') ) {
				this.querySelector('[data-js-free-shipping-slider]').style.width = `${cartSliderWidth}%`;
			}

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount + KROWN.settings.iso_code;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}